import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "el-dropdown-link c_cursor c_flex_row"
};
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import shared from '@/micro/shared';
import { Avatar, SwitchButton } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router';
import { logout } from '@y/api';
export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfo',
  setup(__props) {
    const userInfo = shared.getUser();
    const router = useRouter();
    const handleLogout = () => {
      ElMessageBox.confirm('确认退出吗？', '退出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 注销token
        await logout().finally(() => {
          // 清除用户登录信息
          shared.logoutAndClear({
            name: 'login',
            router
          });
        });
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: '已取消退出'
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createBlock(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: handleLogout
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(SwitchButton))]),
              _: 1
            }), _cache[0] || (_cache[0] = _createTextVNode("退出登录 "))]),
            _: 1,
            __: [0]
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_avatar, {
          class: "c_margin_r5",
          size: 30,
          icon: _unref(Avatar)
        }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_unref(userInfo)?.name), 1)])]),
        _: 1
      });
    };
  }
});